module.exports = __webpack_public_path__ + "img/Bancos.ab1c1aed.png";